import { useEffect } from 'react'

// Мигание заголовка вкладки, пока есть непрочитанные сообщения чата поддержки:
// заголовок переключается между исходным и «Новое сообщение в чате — …».
// При active === false или размонтировании заголовок восстанавливается.
export const usePageTitlePing = (active) => {
	useEffect(() => {
		if (!active || typeof document === 'undefined') return undefined

		const originalTitle = document.title
		const pingTitle = `Новое сообщение в чате — ${originalTitle}`
		let showPing = false

		const interval = setInterval(() => {
			showPing = !showPing
			document.title = showPing ? pingTitle : originalTitle
		}, 1500)

		return () => {
			clearInterval(interval)
			document.title = originalTitle
		}
	}, [active])
}
